import {BrowserRouter,HashRouter, Route, Switch } from "react-router-dom";
import Landing from "pages/Landing";
import {createTheme, ThemeProvider} from "@mui/material/styles";
import {Web3ReactProvider} from "@web3-react/core";
import Web3 from 'web3';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
function getLibrary(provider) {
    return new Web3(provider);
}
function Routes(props) {
    const darkTheme = createTheme({
        palette: {
            mode: "dark",
            background:{
                default: "#050023",
                paper:"rgba(5,0,35,0.9)",
                secondary:"#140E3A"
            },
            primary:{
                main: "rgb(25, 118, 210)"
            }
        },
        typography:{
            fontFamily: "Poppins"
        }
    });

    return (
        <HashRouter>
            <Web3ReactProvider getLibrary={getLibrary}>
                <ThemeProvider theme={darkTheme}>
                    <Switch>
                        <Route exact path="/">
                            <Landing/>
                        </Route>
                        <Route path="/owner/:address">
                            <Landing/>
                        </Route>
                        <Route path="/tokens/:curTokenId">
                            <Landing/>
                        </Route>
                    </Switch>
                    <ToastContainer />
                </ThemeProvider>
            </Web3ReactProvider>
        </HashRouter>
    );
}

export default Routes;
